import { useContext } from 'react'
import { I18nContext } from 'src/components/i18n'
import { IKV } from '../types'

export default function useI18n() {
  const i18n: IKV = useContext(I18nContext)
  return i18n
}
